import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { right } from 'utils';

export const StyledUiDatePicker = styled('div')(
  () => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    position: relative;
    border-radius: 6px;
    box-sizing: border-box;

    &.error {
      border: 1px solid #d32f2f;
      max-height: 46px;
    }

    .custom-range-input {
      padding: 0;
    }

    .MuiFormHelperText-root {
      color: #d32f2f;
      display: block;
      font-size: 0.625rem;
      font-family: inherit !important;
      position: absolute;
      top: 0;
      ${right('0px')}
      margin-top: 48px;
    }
  `
);
